import { GetScreenPopupsQuery } from '~/__generated__/graphql'

export interface ScreenPopupModel {
  id: string
  title: string
  image: string
  rowOrderRank: number
  buttonInfo?: {
    text: string
    color: string
    textColor: string
    redirectUrl: string
  }
  videoId?: string
}

export interface KeyVisualModel {
  id: string
  title: string
  image: string
  videoInfo: {
    id: string
    minutes: number
    seconds: number
    description: string
  }
}

/**
 * apolloが生成した型からネストしている型を抽出する。 (TODO: 理想はクエリ側をFragmentで書いて、その型を使う)
 * NOTE: 基本的に下記の型はファイル内に閉じる
 */
type ExtractEdges<T> = T extends { edges?: Array<infer E> | null } ? E : never
type ExtractNode<T> = T extends { node?: infer E } ? E : never
type ExtractButton<T> = T extends { button?: infer E } ? E : never

type ScreenPopupEdge = ExtractEdges<GetScreenPopupsQuery['screenPopups']>
type ScreenPopupNode = ExtractNode<ScreenPopupEdge>
type ScreenPopupButton = NonNullable<ExtractButton<ScreenPopupNode>>


export function createButtonInfo(buttonInfo: ScreenPopupButton): ScreenPopupModel['buttonInfo'] {
  return {
    text: buttonInfo.text || '',
    color: buttonInfo.color || '',
    textColor: buttonInfo.textColor || '',
    redirectUrl: buttonInfo.url || '',
  }
}
